import { ReviewActionButtons } from "./ActionButtons/ReviewActionButtons";
import { SidebarHeader } from "@/components/layout/SidebarHeader";
import { useComputedValues } from "@/contexts/ComputedValuesContext";
import { useCurrentMedia } from "@/store";

export const ReviewSidebarContent = () => {
    const { hasEnoughDataToDeploy } = useComputedValues();
    const currentMedia = useCurrentMedia();

    const isVideo = currentMedia?.file.isVideo;
    const shouldShowDeployFlow = isVideo || hasEnoughDataToDeploy;

    let title: string;
    let description: string | undefined;

    if (shouldShowDeployFlow) {
        title = "How is your model looking?";
        description =
            "You can adjust the slider to show more or less objects before taking your next action.";
    } else {
        title = "Let's try on more data.";
        description = "Upload more images or a video to improve your model.";
    }

    return (
        <>
            <SidebarHeader title={title} description={description} />
            <ReviewActionButtons forceVideoFlow={shouldShowDeployFlow} />
        </>
    );
};
